"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Form = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _rcForm = require("rc-form");
var _FormItem = _interopRequireDefault(require("./FormItem"));
var _FormCaption = _interopRequireDefault(require("./FormCaption"));
var _FormTitle = _interopRequireDefault(require("./FormTitle"));
var _FormSubHeader = _interopRequireDefault(require("./FormSubHeader"));
var _Grid = require("../Grid");
var _FormContext = require("./FormContext");
var _InputGroup = _interopRequireDefault(require("./InputGroup"));
var _FormGroup = _interopRequireDefault(require("./FormGroup"));
var _validateMessages = require("./validateMessages");
var _StyledForm = require("./StyledForm");
var _ykbStyledComponents = require("../ykb-styled-components");
var _Resizer = require("../Grid/Resizer");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var debounce = function debounce(callback, delay) {
  var timer;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(timer);
    timer = setTimeout(function () {
      return callback.apply(void 0, args);
    }, delay);
  };
};
var Form = exports.Form = /*#__PURE__*/function (_Component) {
  function Form(props) {
    var _this;
    (0, _classCallCheck2.default)(this, Form);
    _this = _callSuper(this, Form, [props]);
    (0, _defineProperty2.default)(_this, "onSubmit", function (e) {
      e.preventDefault();
      _this.props.form.validateFields(function (error, values) {
        if (_this.props.onSubmit && _this.props.debounceSubmit) {
          _this.debouncedSubmit(e, error, values);
        } else if (_this.props.onSubmit && !_this.props.debounceSubmit) {
          _this.props.onSubmit(e, error, values);
        }
      });
    });
    _this.seperatorItem = {
      xs: 0,
      sm: 0,
      md: 0,
      lg: 0
    };
    if (props.debounceSubmit) {
      _this.debouncedSubmit = debounce(function (e, error, values) {
        return _this.props.onSubmit(e, error, values);
      }, 750);
    }
    if (props.observeElement === 'container') {
      _this.container = (0, _Resizer.getContainer)();
    }
    return _this;
  }
  (0, _inherits2.default)(Form, _Component);
  return (0, _createClass2.default)(Form, [{
    key: "handleKeydown",
    value: function handleKeydown(e) {
      e = e || window.event;
      var disableEnterSubmit = this.props.disableEnterSubmit;
      var isEnter = false;
      var isSelect = e.target && e.target.type === 'search';
      var isTextArea = e.target && e.target.type === 'textarea';

      // textarea should not submit on enter
      if ('key' in e) {
        isEnter = e.key === 'Enter';
      } else {
        isEnter = e.keyCode === 13;
      }
      if (isTextArea) {
        return;
      } else if (isSelect && isEnter) {
        e.preventDefault(); // To prevent the situation that occurs when select enter is clicked in select
        return;
      }
      if (isEnter) {
        if (disableEnterSubmit) {
          e.preventDefault();
        } else {
          this.onSubmit(e);
        }
      }
    }
  }, {
    key: "resetSeperatorItem",
    value: function resetSeperatorItem(breakpoints, additional) {
      var _this2 = this;
      var observeElement = this.props.observeElement;
      var defaultBreakpoints = ['xs', 'sm', 'md', 'lg'];
      if (observeElement === 'container') {
        defaultBreakpoints.push('xl');
      }
      if (!breakpoints) {
        breakpoints = defaultBreakpoints;
      }
      breakpoints.forEach(function (breakpoint) {
        _this2.seperatorItem[breakpoint] = additional ? additional['span'] || additional[breakpoint] : 0;
      });
    }
  }, {
    key: "renderSeperator",
    value: function renderSeperator(seperatorObj, child) {
      var _child$props;
      var _this$props = this.props,
        colSpan = _this$props.colSpan,
        ignoreHiddenItemsForSeparation = _this$props.ignoreHiddenItemsForSeparation,
        observeElement = _this$props.observeElement;
      if ((_child$props = child.props) !== null && _child$props !== void 0 && _child$props.hidden && ignoreHiddenItemsForSeparation) return;
      var container = observeElement === 'container' && this.container;
      var seperatorItem = this.seperatorItem;
      var itemColSpan = child.props.colSpan || colSpan;
      Object.keys(seperatorItem).forEach(function (breakpoint) {
        if (itemColSpan['span']) {
          seperatorItem[breakpoint] += itemColSpan['span'];
        } else {
          if (itemColSpan[breakpoint]) {
            seperatorItem[breakpoint] += itemColSpan[breakpoint];
          }
        }
        if (seperatorItem[breakpoint] > 24) {
          seperatorObj.before.push(breakpoint);
        }
        if (seperatorItem[breakpoint] === 24) seperatorObj.after.push(breakpoint);
      });

      //TODO: Kkown bug: Sadece sm verilince colSpan={{ sm: 12 }} seperator a eksik classnamer atiyoruz. :(

      if (seperatorObj.after.length > 0) {
        var cls = (0, _classnames.default)('ykb-form-seperator ykb-form-seperator-after', (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "visible-xs", seperatorItem['xs'] === 24 && !container), "visible-sm", seperatorItem['sm'] === 24 && !container), "visible-md", seperatorItem['md'] === 24 && !container), "visible-lg", seperatorItem['lg'] === 24 && !container), "visible-xs-container", seperatorItem['xs'] === 24 && container), "visible-sm-container", seperatorItem['sm'] === 24 && container), "visible-md-container", seperatorItem['md'] === 24 && container), "visible-lg-container", seperatorItem['lg'] === 24 && container), "visible-xl-container", seperatorItem['xl'] === 24 && container));
        seperatorObj.afterElement = /*#__PURE__*/_react.default.createElement(_Grid.Col, {
          className: cls,
          span: 24,
          observeElement: observeElement
        });
        this.resetSeperatorItem(seperatorObj.after);
      }
      if (seperatorObj.before.length > 0) {
        var _cls = (0, _classnames.default)('ykb-form-seperator ykb-form-seperator-before', (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "visible-xs", seperatorItem['xs'] > 24 && !container), "visible-sm", seperatorItem['sm'] > 24 && !container), "visible-md", seperatorItem['md'] > 24 && !container), "visible-lg", seperatorItem['lg'] > 24 && !container), "visible-xs-container", seperatorItem['xs'] > 24 && container), "visible-sm-container", seperatorItem['sm'] > 24 && container), "visible-md-container", seperatorItem['md'] > 24 && container), "visible-lg-container", seperatorItem['lg'] > 24 && container), "visible-xl-container", seperatorItem['xl'] > 24 && container));
        seperatorObj.beforeElement = /*#__PURE__*/_react.default.createElement(_Grid.Col, {
          className: _cls,
          span: 24,
          observeElement: observeElement
        });
        this.resetSeperatorItem(seperatorObj.before, itemColSpan);
      }
    }
  }, {
    key: "renderChildren",
    value: function renderChildren(children) {
      var _this3 = this;
      var _this$props2 = this.props,
        layout = _this$props2.layout,
        viewMode = _this$props2.viewMode,
        disabled = _this$props2.disabled,
        upperCase = _this$props2.upperCase,
        observeElement = _this$props2.observeElement,
        viewModeWithPrefixSuffix = _this$props2.viewModeWithPrefixSuffix;
      this.resetSeperatorItem();
      return _react.default.Children.map(children, function (child, index) {
        var _child$props2, _child$props3, _child$props4;
        if (!child || ! /*#__PURE__*/_react.default.isValidElement(child)) {
          return;
        } else if (child.type && child.type.description === 'react.fragment' && (_child$props2 = child.props) !== null && _child$props2 !== void 0 && _child$props2.children) {
          return _this3.renderChildren(child.props.children);
        } else if (((_child$props3 = child.props) === null || _child$props3 === void 0 ? void 0 : _child$props3.displayName) !== 'FormItem' && child.type && child.type.description !== 'react.fragment' && (_child$props4 = child.props) !== null && _child$props4 !== void 0 && _child$props4.children) {
          console.error('YKB-FORM: Only <Form.Item> or a <></> (react fragment) can be used as first level items of form!');
          return;
        }
        var seperatorObj = {
          before: [],
          after: [],
          beforeElement: null,
          afterElement: null
        };
        if (layout === 'vertical') {
          _this3.renderSeperator(seperatorObj, child);
        }
        var isViewModeWithPrefixSuffix = viewModeWithPrefixSuffix || child.props.viewModeWithPrefixSuffix;
        var item = /*#__PURE__*/_react.default.cloneElement(child, {
          prefixCls: _this3.props.prefixCls,
          formLayout: _this3.props.layout,
          formColSpan: _this3.props.colSpan,
          formLabelSpan: _this3.props.labelSpan,
          lastChild: children.length - 1 === index,
          viewMode: viewMode,
          disabled: disabled,
          upperCase: upperCase,
          observeElement: observeElement,
          viewModeWithPrefixSuffix: isViewModeWithPrefixSuffix
        });
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, seperatorObj.beforeElement, item, seperatorObj.afterElement);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$props3 = this.props,
        layout = _this$props3.layout,
        children = _this$props3.children,
        form = _this$props3.form,
        viewMode = _this$props3.viewMode,
        className = _this$props3.className,
        _this$props3$UNSAFE_r = _this$props3.UNSAFE_restrictUpdates,
        UNSAFE_restrictUpdates = _this$props3$UNSAFE_r === void 0 ? false : _this$props3$UNSAFE_r,
        showErrors = _this$props3.showErrors,
        upperCase = _this$props3.upperCase,
        disableEnterSubmit = _this$props3.disableEnterSubmit,
        id = _this$props3.id;
      return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
        return /*#__PURE__*/_react.default.createElement(_FormContext.FormProvider, {
          formContext: {
            form: form,
            viewMode: viewMode,
            showErrors: showErrors,
            upperCase: upperCase
          },
          UNSAFE_restrictUpdates: UNSAFE_restrictUpdates
        }, /*#__PURE__*/_react.default.createElement(_StyledForm.StyledForm, {
          id: id,
          $layout: layout,
          $viewMode: viewMode,
          className: className,
          onSubmit: _this4.onSubmit,
          disableEnterSubmit: disableEnterSubmit,
          onKeyDown: function onKeyDown(e) {
            return _this4.handleKeydown(e);
          },
          noValidate: true,
          theme: theme
        }, layout === 'vertical' ? /*#__PURE__*/_react.default.createElement(_Grid.Row, null, _this4.renderChildren(children)) : _this4.renderChildren(children)));
      });
    }
  }]);
}(_react.Component);
(0, _defineProperty2.default)(Form, "Item", _FormItem.default);
(0, _defineProperty2.default)(Form, "InputGroup", _InputGroup.default);
(0, _defineProperty2.default)(Form, "Caption", _FormCaption.default);
(0, _defineProperty2.default)(Form, "Title", _FormTitle.default);
(0, _defineProperty2.default)(Form, "SubHeader", _FormSubHeader.default);
(0, _defineProperty2.default)(Form, "FormGroup", _FormGroup.default);
Form.propTypes = {
  /**
   * Additional CSS ui classes
   */
  className: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.string]),
  layout: _propTypes.default.oneOf(['vertical', 'horizontal']).isRequired,
  viewMode: _propTypes.default.bool,
  prefixCls: _propTypes.default.string,
  colSpan: _propTypes.default.object,
  labelSpan: _propTypes.default.object,
  /**
   * use toUpperCase method
   */
  upperCase: _propTypes.default.bool,
  /**
   * Debounces submit action with 750ms
   */
  debounceSubmit: _propTypes.default.bool,
  showErrors: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  disableEnterSubmit: _propTypes.default.bool,
  observeElement: _propTypes.default.oneOf(['container', 'window'])
};
Form.defaultProps = {
  prefixCls: 'ykb-form',
  layout: 'vertical',
  colSpan: {
    span: 12
  },
  labelSpan: {
    span: 8
  },
  viewMode: false,
  className: '',
  debounceSubmit: true,
  showErrors: true,
  observeElement: 'window',
  disableEnterSubmit: false
};
Form.create = function (options) {
  return (0, _rcForm.createForm)(_objectSpread(_objectSpread({}, options), {}, {
    onValuesChange: function onValuesChange(props, changedValues, formValues) {
      if (props.onValuesChange) props.onValuesChange(changedValues, formValues);
    },
    validateMessages: (0, _validateMessages.messages)()
  }));
};
Form.displayName = 'Form';
var _default = exports.default = (0, _rcForm.createForm)({
  // onFieldsChange(props, changedFields) {
  //   props.onFieldsChange(changedFields);
  // },
  onValuesChange: function onValuesChange(props, changedValues, formValues) {
    if (props.onValuesChange) props.onValuesChange(changedValues, formValues);
  },
  validateMessages: (0, _validateMessages.messages)()
})(Form);